/**
 * Configuration for resume info. Provides information
 * on resume fields and mapping between API names and drupal naming structure.
 */
const jobiqoResumesConfig = require('./../src/jobiqo/config/resume');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const applicantsActive = true;
const resumeActive = true;

module.exports = mergeDeepRight(jobiqoResumesConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    RESUME_FEATURE_ACTIVE: resumeActive,
    APPLICANT_FEATURE_ACTIVE: applicantsActive,
    GEO_INFO: {
      fixtures: [
        {
          label: 'Toronto, ON, Canada',
          location: { lat: 43.65107, lng: -79.347015 },
        },
        {
          label: 'Montreal, QC, Canada',
          location: { lat: 45.501690, lng: -73.567253 },
        },
        {
          label: 'Ontario, Canada',
          location: { lat: 51.253777, lng: -85.323212 },
        },
        {
          label: 'QC, Canada',
          location: { lat: 53.860291, lng: -68.425949 },
        },
        {
          label: 'London, ON, Canada',
          location: { lat: 42.984924, lng: -81.245277 },
        },
        {
          label: 'Ottawa, ON, Canada',
          location: { lat: 45.421532, lng: -75.697189 },
        },
      ],
    },
  },
});
